<script lang="ts" setup>
import { brandingQueries } from '@services/overig/queries/BrandingQueries';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import { useQuery } from '@tanstack/vue-query';
import { reactive } from 'vue';

const state = reactive<{
  imageState: 'error' | 'loaded' | 'loading';
}>({
  imageState: 'loading',
});

const { data: brandingData } = useQuery({
  ...brandingQueries.fetchBranding(),
  select: (result) => result.data.result,
});
</script>

<template>
  <template v-if="brandingData">
    <img
      v-if="state.imageState !== 'error'"
      :alt="brandingData.kantoornaam"
      class="max-h-full"
      :class="{ invisible: state.imageState === 'loading' }"
      :src="`/tpimages/h150/${brandingData.logo}`"
      @error="state.imageState = 'error'"
      @load="state.imageState = 'loaded'"
    />

    <span v-else class="block min-w-0 truncate text-center font-bold text-primary">
      {{ brandingData.kantoornaam }}
    </span>
  </template>

  <VSkeleton v-else height="lg" />
</template>
